let QTemplate = {
  rowId: null,
  questSysId: null, // FK 問卷主檔
  enName: '',
  cnName: '',
  questItemType: 'undefined',
  serial: null, // 題目順序
  isItemImg: false, // 細項是否為影像，沒有細項的題型沒有影響
  isAssign: false, // 是否為指定檢核題目
  inputCheck: null, // 輸入檢查
  isUse: true, // 是否使用
  isRequired: false // 是否必填
}
// 問題種類常數
// 目前還差 file, dateTime, multiChoice
let QType = {
  // 數字滑桿題
  SLIDER: {
    name: 'slider',
    itemType: 22,
    text: '數字滑桿題',
    template: Object.assign(
      { ...QTemplate },
      {
        questItemType: 'slider',
        cnName: '您再次前來本店用餐的意願：',
        miniNum: 1,
        maxiNum: 51,
        numInterval: 5,
        value: null,
        headingFile: null,
        questHeadingPic: null
      }
      )
  },
  RATING: {
    name: 'rating',
    itemType: 26,
    text: '星級評分題',
    template: Object.assign(
      { ...QTemplate },
      { questItemType: 'rating', cnName: '請填入', length: 5, value: null,
      headingFile: null,
      questHeadingPic: null }
    )
  },
  // 文字題
  TEXT: {
    name: 'text',
    itemType: 10,
    text: '文字題',
    template: Object.assign(
      { ...QTemplate },
      {
        questItemType: 'text',
        cnName: '對於本店或服務人員的建議：',
        value: null,
        length: 10,
        headingFile: null,
        questHeadingPic: null
      }
    )
  },
  // 數字題
  NUMERIC: {
    name: 'numeric',
    itemType: 20,
    text: '數字題',
    template: Object.assign(
      { ...QTemplate },
      {
        questItemType: 'numeric',
        miniNum: 1,
        maxiNum: 100,
        cnName: ' 請問您今天是幾位用餐呢？',
        value: null,
        headingFile: null,
        questHeadingPic: null
      }
    )
  },
  // 單選題
  CHOICE: {
    name: 'choice',
    itemType: 14,
    text: '單選題',
    template: Object.assign(
      { ...QTemplate },
      {
        questItemType: 'choice',
        cnName: '這是您第幾次到本店用餐？',
        value: null,
        items: ['第 1 次', '第 2-3 次', '第 4-6 次', '6次以上', '來過，但忘記次數'],
        files: [],
        fileRoutes: [],
        headingFile: null,
        questHeadingPic: null
      }
    )
  },
  // 多選題
  CHOICE_MULTIPLE: {
    name: 'choiceMulti',
    itemType: 16,
    text: '多選題',
    template: Object.assign(
      { ...QTemplate },
      {
        questItemType: 'choiceMulti',
        cnName: '請選擇您喜歡的顏色？',
        value: null,
        items: ['紅色', '藍色', '黃色', '綠色', '黑色'],
        files: [],
        fileRoutes: [],
        headingFile: null,
        questHeadingPic: null
      }
    )
  },
  // 日期題
  DATE: {
    name: 'date',
    itemType: 36,
    text: '日期題',
    template: Object.assign(
      { ...QTemplate },
      {
        questItemType: 'date',
        cnName: '您蒞臨本店用餐的日期',
        value: null,
        headingFile: null,
        questHeadingPic: null
      }
    )
  },
  // 日期時間題
  DATE_TIME: {
    name: 'dateTime',
    itemType: 38,
    text: '日期時間題',
    template: Object.assign(
      { ...QTemplate },
      {
        questItemType: 'dateTime',
        cnName: '您的預約時間',
        value: null,
        headingFile: null,
        questHeadingPic: null
      }
    )
  },
  // 檔案上傳題
  FILE: {
    name: 'file',
    itemType: 32,
    text: '檔案上傳題',
    template: Object.assign(
      { ...QTemplate },
      {
        questItemType: 'file',
        cnName: '這是檔案上傳題測試題目文字部分',
        url: '',
        headingFile: null,
        questHeadingPic: null
      }
    )
  },
  // 矩陣題
  MATRIX: {
    name: 'matrix',
    itemType: 18,
    text: '矩陣題',
    template: Object.assign(
      { ...QTemplate },
      {
        questItemType: 'matrix',
        cnName: '您對於今日用餐的滿意程度：',
        items: ['非常不滿意', '不滿意', '普通', '喜歡', '滿意', '非常滿意'],
        subQues: [
          { rowId: null, cnName: '整體', value: null },
          { rowId: null, cnName: '環境', value: null },
          { rowId: null, cnName: '服務', value: null },
          { rowId: null, cnName: '餐點', value: null },
          { rowId: null, cnName: '價位', value: null }
        ],
        headingFile: null,
        questHeadingPic: null
      }
    )
  }
}
export default QType
